import PageBuilder from '@commons/pagebuilder';

import type { DrupalInsightsView } from '.';

/**
 * Featured display of the insights view.
 *
 * Renders an insight as featured.
 */

const FeaturedDisplay = ({ content }: DrupalInsightsView) => {
  return content.map(PageBuilder.renderNode);
};

export default FeaturedDisplay;
